import { configureStore } from "@reduxjs/toolkit";
import adminAuthReducer from "./AdminAuthSlice";
import userAuthReducer from "./UserAuthSlice";

export const store = configureStore({
  reducer: {
    adminAuth: adminAuthReducer,
    userAuth: userAuthReducer,
  },
});
